export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_09.012ee8e1.jpg";